import { Button } from '@mui/material';
import { sendEmail } from '../../actions/admin';
import { useAppDispatch, useAppSelector } from '../../hooks';

export default function Email() {
  const dispatch = useAppDispatch();
  const message = useAppSelector((s) => s.admin.message);
  return (
    <div className="email">
      <h2>Wysłać maila?</h2>
      {message.text}
      <Button variant="contained" onClick={() => dispatch(sendEmail())}>Tak</Button>
    </div>
  );
}
